module.exports = __webpack_public_path__ + "assets/icon-unordered-list.92ee471f.svg";